import { Badge } from '@/components/ui/badge'
import { cn } from '@/utils/cn'

// Categorical role colors drawn from the --cat-* palette (tokenized; was raw amber/blue).
const ROLE_STYLES: Record<string, string> = {
  owner: 'bg-cat-5/10 text-cat-5 border-cat-5/20',
  collaborator: 'bg-cat-1/10 text-cat-1 border-cat-1/20',
  viewer: 'bg-muted text-muted-foreground border-border',
}

export function RoleBadge({ role }: { role: string }) {
  return (
    <Badge variant="outline" className={cn('shrink-0 text-xs capitalize', ROLE_STYLES[role])}>
      {role}
    </Badge>
  )
}
